module.exports = __webpack_public_path__ + "static/media/mavic2_dark.f4692100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/mavic2_dark.jpg
// module id = 317
// module chunks = 0